import { apiClient } from '@/shared/lib/apiClient';
import type { ApiResponse } from '@/types';

export type SosEventAction =
  | 'opened'
  | 'emergency_call'
  | 'ice_call'
  | 'ice_sms'
  | 'ice_whatsapp'
  | 'guide_call'
  | 'guide_whatsapp'
  | 'share'
  | 'copy'
  | 'copy_location'
  | 'dismissed'
  | 'ice_saved';

export interface SosEventLocation {
  lat: number;
  lng: number;
  accuracy?: number;
}

export interface LogSosEventPayload {
  action: SosEventAction;
  location?: SosEventLocation;
}

export interface SosEventResponse {
  id: string;
  bookingId: string;
  action: SosEventAction;
  createdAt: string;
}

export const sosApi = {
  async logEvent(bookingId: string, payload: LogSosEventPayload) {
    const response = await apiClient.post<ApiResponse<SosEventResponse>>(
      `/bookings/${bookingId}/sos/events`,
      payload
    );
    return response.data.data!;
  },
};
